import { useState } from "react";
import "./index.css";
import { Separator } from "@/components/ui/separator";
import { Toaster } from "@/components/ui/sonner";
import { ImageGeneratorForm } from "./components/ImageGeneratorForm";
import { ImageDisplay } from "./components/ImageDisplay";
import { SecurityWarning } from "./components/SecurityWarning";
import { generateImage, type ImageGenerationParams } from "./lib/image-service";
import { toast } from "sonner";

export function App() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [generatedImage, setGeneratedImage] = useState<string | undefined>(undefined);
  const [generatedImageUrl, setGeneratedImageUrl] = useState<string | undefined>(undefined);
  const [currentPrompt, setCurrentPrompt] = useState<string | undefined>(undefined);
  const [currentModel, setCurrentModel] = useState<string | undefined>(undefined);
  const [currentFileFormat, setCurrentFileFormat] = useState<string>("webp");

  const handleGenerateImage = async (formValues: any) => {
    try {
      setIsGenerating(true);
      setCurrentPrompt(formValues.prompt);
      setCurrentModel(formValues.model);
      setCurrentFileFormat(formValues.extra_body.response_extension);
      
      // 清除之前的图像数据
      setGeneratedImage(undefined);
      setGeneratedImageUrl(undefined);
      
      const result = await generateImage(formValues);
      
      // 根据响应格式设置状态
      if (result.b64_json) {
        setGeneratedImage(result.b64_json);
      } else if (result.url) {
        setGeneratedImageUrl(result.url);
      }
      
      toast.success("图像生成成功！");
    } catch (error) {
      console.error("图像生成错误:", error);
      toast.error("生成图像失败。请检查您的API密钥和参数。");
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-4xl font-bold mb-2">AI图像生成器</h1>
        <p className="text-muted-foreground">
          配置参数、输入提示词，生成AI图像
        </p>
      </div>
      
      <SecurityWarning />
      
      <Separator className="my-6" />
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <ImageGeneratorForm 
            onGenerate={handleGenerateImage} 
            isGenerating={isGenerating} 
          />
        </div>
        <div>
          <ImageDisplay 
            imageData={generatedImage} 
            imageUrl={generatedImageUrl}
            promptText={currentPrompt}
            modelName={currentModel}
            fileFormat={currentFileFormat}
            isLoading={isGenerating} 
          />
        </div>
      </div>
      
      <Toaster />
    </div>
  );
}

export default App;
